import { errorAction } from './notifications';
import { throwErrorIfNotHandled } from './errorMiddleware';

export function handleSapPaymentRequestsError(err, dispatch) {
    if (err.status === 422) {
        err.json().then(({ errors }) => {
            if (errors) {
                dispatch(errorAction(`Failed to fetch WINGS PO - ${errors}`));
            } else {
                dispatch(errorAction(`Failed to fetch WINGS PO`));
            }
        });
    } else {
        throwErrorIfNotHandled(`Failed to fetch WINGS PO`)(err);
    }
}
